import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Airport } from "../@types";

function useIntlAirports(
  options?: QueryObserverOptions<APIResponse<Airport[]>, APIError>
) {
  const {
    data: airportsData,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Airport[]>, APIError>(
    "intl-airports",
    () =>
      get(API_URL + "/aviation/international/airports", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    airportsData,
    isError,
    error,
    isLoading,
  };
}

export default useIntlAirports;
